var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noViewContainer"},[_c('el-result',{attrs:{"icon":"warning","title":"信息提示","subTitle":"您没有权限访问该模块，若想开通此模块，请联系管理员"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }